import { createRouter, createWebHistory } from 'vue-router';
import App from '../App.vue';
import Workplace from '../workplace/WorkplaceIndex.vue';
import Ecard from '../eworkcard/EcardIndex.vue';

const routes = [
  {
    path: '/',
    component: App,
  },
  {
    path: '/workplace',
    component: Workplace,
  },
  {
    path: '/eworkcard',
    component: Ecard,
    meta: { title: '电子工牌' },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
